import React from "react";
import LayoutGlobal from "../components/layout/index"
import { Layout, Row, Col, Icon, Button } from "antd";
import ScrollAnimation from 'react-animate-on-scroll';
import '../css/teseo.css';
import { SectionHeader } from "../components/SectionHeader";
import Head from "../components/layout/Head";
const { Content } = Layout;

function IndexPage() {
  return (
    <LayoutGlobal>
      <Head
        title="Assistenza Clienti - Teknomaint Sistemi Informatici"
        description="Scopri la differenza! Hai bisogno di assistenza? Scarica livelet per entrare in contatto con i nostri operatori."
      />
      <div style={{ padding: '0px 0px 20px 0px' }}>
        <SectionHeader
          title={<h1 className="color-white">Assistenza Clienti</h1>}
          description={<h3 className="color-white">Scopri la differenza!</h3>}
        />
        <Content className="container-app">
          <div className="content-app" style={{ minHeight: 650 }}>
            <Row align="middle" justify="center" type="flex" className="padding-container-item">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-col">
                <ScrollAnimation animateIn="fadeIn" animateOnce={true} duration={1}>
                  <h1>HAI BISOGNO DI TELEASSISTENZA?</h1>
                  <h3>SCARICA LIVELET PER ENTRARE IN CONTATTO CON I NOSTRI OPERATORI</h3>
                </ScrollAnimation>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-center padding-col">
                <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} duration={1}>
                  <h1>WINDOWS</h1>
                  <img src="/images/loghi/windows-logo.png" alt="Windows Logo" width="100px" />
                  <div className="clear"></div>
                  <Button href="/livelet/LiveLet.exe" type="primary" size={'large'} ghost className="button-tekno button-tekno-black" style={{ marginTop: 25 }}>Scarica Windows LiveLet <Icon type="download" /></Button>
                </ScrollAnimation>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-center padding-col">
                <ScrollAnimation animateIn="fadeInRight" animateOnce={true} duration={1}>
                  <h1>MAC</h1>
                  <img src="/images/loghi/apple-logo.jpg" alt="Mac Logo" width="100px" />
                  <div className="clear"></div>
                  <Button href="/livelet/LiveLet.dmg" type="primary" size={'large'} ghost className="button-tekno button-tekno-black" style={{ marginTop: 25 }}>Scarica MAC LiveLet<Icon type="download" /></Button>
                </ScrollAnimation>
              </Col>
            </Row>
          </div>
        </Content>
      </div>
    </LayoutGlobal >
  );

}


export default IndexPage;
